import {
   ApplicationRef,
   ComponentFactoryResolver,
   ComponentRef,
   Injectable,
   Injector
  } from '@angular/core';
import { LoadingComponent } from './loading.component';

@Injectable()
export class LoadingService {
  public componentRef: ComponentRef<any>;
  private containerEl = document.querySelector('body');
  constructor(
    private resolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector
  ) {}
  start(data?: any, time?: any) {
    if (!this.componentRef) {
      const componentFactory = this.resolver.resolveComponentFactory(
        LoadingComponent
      );
      this.componentRef = componentFactory.create(this.injector);
      this.applicationRef.attachView(this.componentRef.hostView);
      this.containerEl.appendChild(this.componentRef.location.nativeElement);
      if (data) {
        this.componentRef.instance.initiateTimer(time, data);
      }
    } else {
      this.componentRef.instance.stopTimer();
      if (data) {
        this.componentRef.instance.initiateTimer(time, data);
      }
    }
  }

  stop() {
    if (this.componentRef) {
      const loadingElement = this.componentRef.location.nativeElement;
      if (loadingElement && loadingElement.parentNode) {
        loadingElement.parentNode.removeChild(loadingElement);
      }
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }
}
